import type ISchoolPeriodUserRepository from '@/core/domain/school/user/ISchoolPeriodUserRepository'
import type { AvailableEducationalMember } from '@/core/domain/school/user/AvailableEducationalMember'
import type { PaginationOptions, PaginatedResponse } from '@/core/domain/resources/types/Pagination'

export default class FetchAvailableEducationalMembersUseCase {
  private readonly schoolPeriodUserRepository: ISchoolPeriodUserRepository

  constructor(schoolPeriodUserRepository: ISchoolPeriodUserRepository) {
    this.schoolPeriodUserRepository = schoolPeriodUserRepository
  }

  async execute(
    schoolId: number,
    periodId: number,
    options?: PaginationOptions
  ): Promise<PaginatedResponse<AvailableEducationalMember>> {
    return await this.schoolPeriodUserRepository.fetchAvailableEducationalMembers(
      schoolId,
      periodId,
      options
    )
  }
}